
export function msg(info, top, duration) {
  top = top || 70
  duration = duration || 1.5
  this.$Message.config({ top: top })
  this.$Message.info({
    content: info,
    duration: duration
  })
}
